module.exports = __webpack_public_path__ + "static/media/33.9b787817.png";